import { getActiveInvitations } from '@/store/module/member/action/getActiveInvitations.js';
import { invite } from '@/store/module/member/action/invite.js';
import { revokeInvitation } from '@/store/module/member/action/revokeInvitation.js';

export const actions = {
	getActiveInvitations,
	invite,
	revokeInvitation
};
